import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoCondicaoPagamentoSelectComponent } from './novo-condicao-pagamento-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoCondicaoPagamentoSelectComponent],
  exports: [NovoCondicaoPagamentoSelectComponent],
})
export class NovoCondicaoPagamentoSelectModule {}
